import * as React from 'react';

function ZezamiiAccessIcon({ color = '#545454', ...props }) {
	return (
		<svg width={18} height={18} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M9.46 12h9.066M9.44 7.297l.01-1.163M7.474 2h3.712a2 2 0 012 2v16a2 2 0 01-2 2H7.474a2 2 0 01-2-2V4a2 2 0 012-2z'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<rect x={16.0391} y={0.994141} width={7.08392} height={7.64024} rx={1.5} fill={color} />
			<path d='M17.83 6.994V6.42l2.286-3.208h-2.291v-.799h3.508v.575l-2.289 3.208h2.293v.8H17.83z' fill={color === 'white' ? '#545454' : 'white'} />
		</svg>
	);
}

export default ZezamiiAccessIcon;
